var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DeuxSmartphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10.5 5 C 8.019 5 6 7.019 6 9.5 L 6 30.5 C 6 32.981 8.019 35 10.5 35 L 20 35 L 20 32 L 10.5 32 C 9.673 32 9 31.327 9 30.5 L 9 9.5 C 9 8.673 9.673 8 10.5 8 L 21.5 8 C 22.327 8 23 8.673 23 9.5 L 23 12.03125 C 23.879 11.46625 24.901 11.109391 26 11.025391 L 26 9.5 C 26 7.019 23.981 5 21.5 5 L 10.5 5 z M 26.5 13 C 24.032499 13 22 15.032499 22 17.5 L 22 38.5 C 22 40.967501 24.032499 43 26.5 43 L 37.5 43 C 39.967501 43 42 40.967501 42 38.5 L 42 17.5 C 42 15.032499 39.967501 13 37.5 13 L 26.5 13 z M 26.5 16 L 37.5 16 C 38.346499 16 39 16.653501 39 17.5 L 39 38.5 C 39 39.346499 38.346499 40 37.5 40 L 26.5 40 C 25.653501 40 25 39.346499 25 38.5 L 25 17.5 C 25 16.653501 25.653501 16 26.5 16 z M 14.5 26 A 1.50015 1.50015 0 1 0 14.5 29 L 17.5 29 A 1.50015 1.50015 0 1 0 17.5 26 L 14.5 26 z M 30.5 34 A 1.50015 1.50015 0 1 0 30.5 37 L 33.5 37 A 1.50015 1.50015 0 1 0 33.5 34 L 30.5 34 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DeuxSmartphones);
export default __webpack_public_path__ + "static/media/icons8-deux-smartphones.1fc36a1e747d6b6085c621c429c645a0.svg";
export { ForwardRef as ReactComponent };